module.exports = __webpack_public_path__ + "img/paidstatu.8f1ce76d.png";